import { render } from "./StepOne.vue?vue&type=template&id=1bb1bd70&scoped=true"
import script from "./StepOne.vue?vue&type=script&lang=js"
export * from "./StepOne.vue?vue&type=script&lang=js"

import "./StepOne.vue?vue&type=style&index=0&id=1bb1bd70&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bb1bd70"]])

export default __exports__